"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withOidcSecure = exports.OidcSecure = void 0;
const react_1 = __importStar(require("react"));
const oidc_1 = __importDefault(require("./vanilla/oidc"));
const OidcSecure = ({ children, callbackPath = null, extras = null, configurationName = "default" }) => {
    const getOidc = oidc_1.default.get;
    const oidc = getOidc(configurationName);
    (0, react_1.useEffect)(() => {
        if (!oidc.tokens) {
            oidc.loginAsync(callbackPath, extras);
        }
        return () => {
        };
    }, [configurationName, callbackPath, extras]);
    if (!oidc.tokens) {
        return null;
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.OidcSecure = OidcSecure;
const withOidcSecure = (WrappedComponent, callbackPath = null, extras = null, configurationName = "default", state = undefined) => (props) => {
    return react_1.default.createElement(exports.OidcSecure, { state: state, callbackPath: callbackPath, extras: extras, configurationName: configurationName },
        react_1.default.createElement(WrappedComponent, Object.assign({}, props)));
};
exports.withOidcSecure = withOidcSecure;
//# sourceMappingURL=OidcSecure.js.map